import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import { AdcAppShell } from "./app-shell";

const PageCompanyKpi = lazy(() =>
  import("@/pages/company-kpi").then(({ PageCompanyKpi }) => ({
    default: PageCompanyKpi,
  }))
);
const PageLanding = lazy(() =>
  import("@/pages/landing").then(({ PageLanding }) => ({
    default: PageLanding,
  }))
);
const PageNoSubscription = lazy(() =>
  import("@/pages/no-subscription").then(({ PageNoSubscription }) => ({
    default: PageNoSubscription,
  }))
);

export const AppRoutes = () => (
  <Suspense fallback={null}>
    <Routes>
      <Route element={<AdcAppShell />}>
        <Route
          path="/view/entityTypes/:entityTypeName/entities/:entityName"
          element={<PageCompanyKpi />}
        />
        <Route path="/" element={<PageLanding />} />
      </Route>
      <Route path="/no-subscription" element={<PageNoSubscription />} />
    </Routes>
  </Suspense>
);
